<div class="container bg-whitesmoke py-4">
  <app-breadcrumb></app-breadcrumb>
  
  <mat-card class="mb-4">
    <mat-card-content>
      <mat-form-field class="w-100">
        <mat-label>Select Card</mat-label>
        <mat-select [formControl]="selectedCardControl">
          <mat-option *ngFor="let card of cards" [value]="card.id">
            {{card.contact_info?.contactName || card.business_info?.businessName || 'Untitled Card'}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="row mb-4" *ngIf="!loading">
    <!-- Visit Count Card -->
    <div class="col-md-6">
      <mat-card class="stats-card">
        <mat-card-content>
          <div class="stat-value">{{ counts['visited'] || 0 }}</div>
          <div class="stat-label">Total Visits</div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Bookmark Count Card -->
    <div class="col-md-6">
      <mat-card class="stats-card">
        <mat-card-content>
          <div class="stat-value">{{ counts['bookmarked'] || 0 }}</div>
          <div class="stat-label">Total Bookmarks</div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Event Type Filter -->
  <mat-card class="mb-4">
    <mat-card-content>
      <mat-form-field class="w-100">
        <mat-label>Filter by Event Type</mat-label>
        <mat-select [(value)]="selectedEventType" (selectionChange)="filterEvents($event.value)">
          <mat-option value="all">All Events</mat-option>
          <mat-option *ngFor="let type of eventTypes" [value]="type">
            {{type | titlecase}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <!-- Events Table -->
  <mat-card>
    <mat-card-content>
      <table mat-table [dataSource]="filteredEvents" class="w-100">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let event"> {{event.name || '-'}} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let event"> {{event.email || '-'}} </td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Phone </th>
          <td mat-cell *matCellDef="let event"> {{event.phone || '-'}} </td>
        </ng-container>

        <!-- Event Type Column -->
        <ng-container matColumnDef="eventType">
          <th mat-header-cell *matHeaderCellDef> Event Type </th>
          <td mat-cell *matCellDef="let event"> {{event.eventType | titlecase}} </td>
        </ng-container>

        <!-- Created At Column -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let event"> 
            {{event.createdAt._seconds ? (event.createdAt._seconds * 1000 | date:'medium') : (event.createdAt | date:'medium')}} 
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div *ngIf="filteredEvents.length === 0" class="no-data">
        No events found.
      </div>
    </mat-card-content>
  </mat-card>
</div>